import type { UpdateTutorPayload } from '../api/update.hook'

import { useTutorKanbanStore } from './store'
import { useUpdateTutorApi } from '../api/update.hook'
import { useTutorKanbanSelectReason } from './tutor-kanban-select-reason.hook'
import { useTutorKanbanSelectCategory } from './tutor-kanban-select-category.hook'

interface TutorKanbanSaveReturn {
  setSubmitUpdate: () => Promise<void>
}

export const useTutorKanbanSave = (): TutorKanbanSaveReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const reason = useTutorKanbanSelectReason()
  const category = useTutorKanbanSelectCategory()

  const isFormValid = (): boolean => {
    if (reason.isVisible.value && reason.refValue.value.length === 0) return false
    return !(category.isRequired.value && !category.refValue.value)
  }

  const setSubmitUpdate = async (): Promise<void> => {
    const tutor = tutorKanbanStore.getTutor
    if (!tutor) return

    if (reason.hasPendingChange.value) {
      reason.setConfirmRequest()
      return
    }

    if (!isFormValid()) {
      tutorKanbanStore.setIsValid(false)
      return
    }

    tutorKanbanStore.setIsValid(true)

    const hasSavedStageDetails = tutorKanbanStore.getSavedStageReasons.length > 0
      || tutorKanbanStore.getSavedStageCategories.length > 0

    const hasStageDetails = reason.isVisible.value || category.isVisible.value || hasSavedStageDetails

    const payload: UpdateTutorPayload = {
      stage: tutor.stage,
      kanban_priority: tutor.kanban_priority,
      stage_deadline: tutor.stage_deadline,
      agent_id: tutor.agent?.id ?? null,
      ...(hasStageDetails && {
        stage_details: {
          reasons: reason.refValue.value,
          categories: category.refValue.value ? [category.refValue.value] : [],
        },
      }),
    }

    await useUpdateTutorApi({
      tutorId: tutor.id,
      payload,
    })
  }

  return {
    setSubmitUpdate,
  }
}
